import script from "./HrTitleMenuBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTitleMenuBtn.vue?vue&type=script&setup=true&lang=js"

import "./HrTitleMenuBtn.vue?vue&type=style&index=0&id=1785ab31&lang=scss"

const __exports__ = script;

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QMenu,QBtn});
